import Vue from "vue"
import "./plugins/vuetify"
import App from "./App.vue"
import router from "./router/"
import store from "./store"
import "roboto-fontface/css/roboto/roboto-fontface.css"
import "font-awesome/css/font-awesome.css"
import axios from 'axios'
import VueGoogleCharts from 'vue-google-charts'
import StarRating from 'vue-star-rating'
import Pagination    from 'vue-pagination-2';


axios.defaults.withCredentials = true;
Vue.prototype.$http = axios
Vue.prototype.$http.defaults.headers.common['Authorization'] = GetCookie('access_token')

function GetCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
      }
  }
  return "";
}

Vue.config.productionTip = false

Vue.component('star-rating', StarRating);
Vue.component('pagination', Pagination);
Vue.use(VueGoogleCharts)
Vue.prototype.$eventHub = new Vue()
Vue.use(require('vue-moment'));

new Vue({
  router,
  store,
  render: h => h(App),
  created(){ 
    this.$eventHub.$emit("LOADING",'true')
    this.$http.post(`${ store.getters.GetProductionUrl}/login/verifysession`)
              .then(response =>{
                
                if(response['data'] && response['data']['clearCookie']){

                  document.cookie = 'access_token' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                  this.$router.push('/login')
                  this.$eventHub.$emit("LOADING",'false');  
                                
                }else{

                  this.$eventHub.$emit("LOADING",'false');
                }
                
              })
              .catch(error =>{

                  this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Session Expired","Color":"red","Close": false });
              
              })
  }
}).$mount("#app")